// extracted by css-extract-rspack-plugin
export default {"CommentBox":"IssueCommentEditor-module__CommentBox__nsX9I8n","EditorMarginContainer":"IssueCommentEditor-module__EditorMarginContainer__KNih_h9"};